var map = {
	"./pic0.png": "5255",
	"./pic1.png": "d369",
	"./pic2.png": "41bd",
	"./pic3.png": "6f2e",
	"./pic4.png": "fe87",
	"./pic5.png": "3772",
	"./pic6.png": "3370",
	"./pic7.png": "8e0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77b4";